import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  dashboardRootContainer: (props: any) => ({
    marginTop: "84px",
  }),
});
export default useStyles;
